import(/* webpackMode: "eager" */ "/vercel/path0/app/(public)/faq/page.tsx");
